import React from 'react';
import { Container, Typography, Box, Grid, Paper, Chip } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import './Education.scss';

const Education = () => {
  const educationData = [
    {
      degree: 'Master of Science in Computer Science',
      specialization: 'AI & ML Track',
      university: 'Binghamton University, SUNY',
      college: 'Thomas J. Watson College of Engineering and Applied Science',
      location: 'Binghamton, NY',
      graduationDate: 'December 2023',
      gpa: '3.94/4.00',
      highlights: ['AI & ML Track', 'Research in NLP', 'Teaching Assistant']
    },
    {
      degree: 'Bachelor of Technology',
      specialization: 'Electronics and Communication Engineering',
      university: 'VNR Vignana Jyothi Institute of Engineering and Technology',
      college: 'VNR VJIET',
      location: 'Hyderabad, India',
      graduationDate: 'April 2018',
      gpa: '7.22/10.0',
      highlights: ['Electronics & Communication', 'Engineering Fundamentals']
    }
  ];

  return (
    <section id="education" className="education-section">
      <Container maxWidth="lg">
        <Typography variant="h2" className="section-title" gutterBottom>
          Education
        </Typography>
        <Box className="section-divider" />
        <Grid container spacing={3}>
          {educationData.map((edu, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Paper elevation={3} className="education-card">
                <Box className="education-header">
                  <SchoolIcon className="education-icon" />
                  <Box>
                    <Typography variant="h5" className="degree-title">
                      {edu.degree}
                    </Typography>
                    <Typography variant="h6" className="specialization">
                      {edu.specialization}
                    </Typography>
                  </Box>
                </Box>
                <Box className="education-details">
                  <Typography variant="body1" className="university">
                    {edu.university}
                  </Typography>
                  <Typography variant="body2" className="college">
                    {edu.college}
                  </Typography>
                  <Typography variant="body2" className="location">
                    {edu.location}
                  </Typography>
                  <Box className="education-meta">
                    <Chip 
                      label={`GPA: ${edu.gpa}`} 
                      size="small"
                      className="gpa-chip"
                      sx={{
                        background: 'linear-gradient(135deg, #345995, #3498db)',
                        color: 'white',
                        border: 'none',
                        fontWeight: 700,
                        boxShadow: '0 2px 8px rgba(52, 89, 149, 0.3)',
                      }}
                    />
                    <Typography variant="body2" className="graduation-date">
                      {edu.graduationDate}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default Education;

